"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortTitleToCourseFactory = function (courses) {
    var courseMap = courses.reduce(function (map, course) {
        map[course.course_title.toLowerCase()] = course;
        return map;
    }, {});
    return function (titles) {
        if (!Array.isArray(titles)) {
            titles = [titles];
        }
        return titles
            .map(function (title) { return courseMap[title.toLowerCase()]; })
            .filter(function (course) { return course; });
    };
};
//# sourceMappingURL=shortTitleToCourse.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/shortTitleToCourse.js
// module id = 464
// module chunks = 22